export default __webpack_public_path__ + "static/media/chat.36f272c4.svg";